import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function StatutoryAndGovernmentApprovals() {

  useEffect(() => {
    document.title = "Statutory And Government Approvals Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <><Navbar />
    <div className="law">
      
      <section className="specializations-detail">
          <div className="container">
          <div className="header-image">
            <img 
              src="./Satutory.jpg" 
              alt="Statutory and Government Approvals" 
              loading="lazy" 
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
              Our dynamic team of experts excels in obtaining essential statutory approvals needed for various purposes under Indian regulations. We have executed several projects, guiding clients through the licensing processes and obtaining critical permits under required laws. Our process combines strategic foresight with streamlined efficiency to meet your business goals within the specified timeline.
            </p>
            <div className="button-container">
              <Link to="/contact">
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
    </div>
    <Footer />
    </>
  );
}

export default StatutoryAndGovernmentApprovals;


